export interface RuntimeConfig {
  apiUrl: string;
  authMode: 'cognito' | 'dev';
  region: string;
  userPoolId: string;
  userPoolClientId: string;
}

let config: RuntimeConfig | null = null;

/**
 * Deployed builds read /config.json (written by the CDK stack), so one build
 * works for every stage. `npm run dev` falls back to the local API.
 */
export async function loadConfig(): Promise<RuntimeConfig> {
  if (config) return config;
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (res.ok && res.headers.get('content-type')?.includes('json')) {
      config = (await res.json()) as RuntimeConfig;
      return config;
    }
  } catch {
    // fall through to local defaults
  }
  config = {
    apiUrl: import.meta.env.VITE_API_URL ?? `http://${location.hostname}:3001`,
    authMode: 'dev',
    region: 'us-east-1',
    userPoolId: '',
    userPoolClientId: '',
  };
  return config;
}

export function getConfig(): RuntimeConfig {
  if (!config) throw new Error('config not loaded');
  return config;
}
